module.exports = __webpack_public_path__ + "static/img/attachment-doc.4702bc2f.png";